import FormButton from "components/FormButton";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSelector,useDispatch} from "react-redux";
import { useNavigate } from "react-router-dom";
import {Row} from "react-bootstrap";
import{fetchSuccessPageContent} from "api/dashboardDetail"
import { useEffect, useState} from "react";
import{setSuccessPageContent,clearSuccessPageContent} from "redux/popupReducer"
import "./index.scss";
const ConfirmationPopup = (props) => {
  const {confirmation_content} = props;
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const navigate = useNavigate();
  const isUserVerified = useSelector((state) => state.userInfo?.userDetail?.is_verified);
  const organisation_id = useSelector((state) => state.configurationReducer?.config?.organisation_id);
  const confirmationContent = useSelector((state) => state?.popupReducer?.successPageContent);
  const dispatch = useDispatch()


  const handleClick = () => {
    clearSuccessPageContent()
    if(primaryUser?.created_by && !isUserVerified){
      props.onFormButtonClick();
      navigate(`/update-successful`)
    } else{
      props.onFormButtonClick();
    }
  };



  useEffect(() => {
    if(props?.show ==  true && props?.confirmation_content?.trigger){
      let params = {
        organisation_id: organisation_id,
        trigger: props?.confirmation_content?.trigger,
      };
      fetchSuccessPageContent(params).then((response)=>{
        dispatch(setSuccessPageContent(response?.data?.email_template_body))
      })    
  }
},[props?.show]);

  return (
    <>
      <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className=""
    >
      <div id="confirmation-popup">
        <Modal.Header id="modal-header">
          <Modal.Title id="contained-modal-center-title">
            {props.confirmation_content?.heading}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body id="modal-body-content">
          {/* <h4>Centered Modal</h4> */}
          { confirmationContent ? 
           <div   dangerouslySetInnerHTML={{__html: confirmationContent}}/>
            : <p>{props.confirmation_content?.content}</p>
           }
        </Modal.Body>
        <Modal.Footer id="modal-footer" className="p-1">
          {  confirmation_content?.buttons &&
            confirmation_content?.buttons.length ? (
            <FormButton
              className={confirmation_content?.buttons_classname}
              formButtons={confirmation_content?.buttons}
              handleNext={handleClick}
              handleBack={props.onHide}
            />
          ) : (
            <>
              <Button onClick={props.onHide} className="light_button">
                Back
              </Button>
              <Button onClick={handleClick} className="primary_button">
                Proceed
              </Button>
            </>
          )}
        </Modal.Footer>
      </div>
    </Modal>
     
    
    </>
  );
};

export default ConfirmationPopup;
